/* global FB */

export const fetchFbPublicProfile = () =>
  new Promise(resolve => {
    FB.api('/me', publicProfile => resolve(publicProfile), {
      fields: 'name,email',
    });
  });

export const fetchProfilePicture = fbUserID =>
  new Promise(resolve => {
    FB.api(`/${fbUserID}/picture`, profilePicture => resolve(profilePicture));
  });

export const checkLoginStatus = () =>
  new Promise(resolve => {
    FB.getLoginStatus(response => resolve(response));
  });

export const facebookLogin = () =>
  new Promise(resolve => {
    FB.login(response => resolve(response), {
      scope: 'public_profile,email,user_birthday',
    });
  });



// WEBPACK FOOTER //
// ./app/services/facebookSDK.js